var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('label',[_vm._v("Date")]),_c('v-input',{attrs:{"cols":"12","md":"6","type":"date"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }